<template>
	<div class="puzzle-detail">
		<div class="w-w-full">
			<div class="ability-detail-body-title" style="">{{ filterBody }}</div>
			<div _flex="~ wrap">
				<div class="ability-detail-resource w-ml-10px" v-for="(item, index) in srcResource" :key="index">
					<audio
						class="ability-detail-audio"
						controls
						:src="item.src"
						v-if="item.type === 'audio'"
						controlslist="noplaybackrate nodownload"
					></audio>
					<video
						class="ability-detail-audio"
						controls
						:src="item.src"
						v-else-if="item.type === 'video'"
						controlslist="noplaybackrate nodownload"
						style="max-height: 500px;"
					></video>
					<img :src="item.src" v-else />
				</div>
			</div>
		</div>
		<div class="top">
			<div ref="puzzle" class="puzzle"></div>
		</div>

		<div class="bottom">
			<span class="tip">将下列图块拖动到上方拼图区</span>
			<div ref="puzzleBlockContainer" class="puzzle-block-container" />
		</div>
	</div>
</template>

<script>
import { createPuzzlePieces } from '@/utils/puzzle'

export default {
	props: {
		filterBody: {
			type: String,
			default: '',
			require: true
		},
		srcResource: {
			type: Array,
			default: () => [],
			require: true
		},
		data: {
			type: Object,
			default: () => {},
			require: true
		}
	},
	computed: {
		num() {
			return this.data.num
		},
		pic() {
			return this.data.pic
		},
		tip() {
			return this.data.tip
		}
	},
	data() {
		return {
			puzzleElements: []
		}
	},
	async mounted() {
		this.puzzleElements = await createPuzzlePieces(this.$refs.puzzle, 300, this.num, this.pic, 'mess')
		this.puzzleElements.forEach(element => {
			element.classList.add('puzzle-block')
			this.$refs.puzzleBlockContainer.appendChild(element)
		})

		/** 占位 */
		this.puzzleElements.forEach(element => {
			const el = document.createElement('div')
			el.style.opacity = 0
			el.style.width = element.style.width
			el.classList.add('puzzle-block')
			this.$refs.puzzleBlockContainer.appendChild(el)
		})
	}
}
</script>

<style lang="scss" scoped>
.puzzle-detail {
	padding: 50px;
	display: flex;
	flex-direction: column;
	align-items: center;
}
.top {
	display: flex;
	align-items: center;

	.puzzle {
		display: flex;
		flex-wrap: wrap;
		border: 1px solid #aaaaaa;
	}
}

.bottom {
	margin-top: 20px;
	width: 898px;
	border-radius: 12px;
	border: 1.5px solid #c6c6c6;
	background: #fff;
	display: flex;
	flex-direction: column;
	justify-content: center;
	box-sizing: border-box;
	padding: 20px;

	.tip {
		color: #424242;
		font-size: 20px;
		font-weight: bold;
		line-height: 22px;
	}

	.puzzle-block-container {
		justify-content: space-evenly;
		margin-top: 15px;
		display: flex;
		flex-wrap: wrap;
	}

	::v-deep(.puzzle-block-container) {
		.puzzle-block {
			margin: 10px;
			flex-shrink: 0;
			border-radius: 20px;
		}
	}
}

.title {
	color: #3e3e3e;
	font-size: 26px;
	line-height: 41px;
	align-self: flex-start;
}

.ability-detail {
	background: #ffffff;
	border-radius: 8px 8px 8px 8px;
	min-height: inherit;
	overflow: hidden;
	img {
		height: 180px;
	}
	.ability-detail-header {
		display: flex;
		align-items: center;
		font-size: 16px;
		padding: 15px 15px 15px 25px;
		cursor: pointer;
	}
	.ability-detail-header:hover {
		color: #ff5e2a;
	}
	.ability-detail-subheader {
		display: flex;
		justify-content: space-between;
		background: #fbfbfb;
		height: 61px;
		margin-left: 21px;
	}
	.ability-detail-num {
		font-size: 16px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #565656;
		margin-right: 7px;
	}
	.ability-detail-id {
		width: 68px;
		height: 27px;
		background: #ebebeb;
		border-radius: 2px 2px 2px 2px;
		margin-right: 21px;
		font-size: 12px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #757575;
	}
	.ability-detail-row {
		height: 27px;
		background: #ebebeb;
		border-radius: 2px 2px 2px 2px;
		font-size: 14px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #757575;
		padding: 0 14px;
	}
	.ability-detail-total {
		margin-right: 8px;
		font-size: 12px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #757575;
	}
	.ability-detail-icon-left {
		width: 31px;
		height: 32px;
		background: #eeeeee;
		margin-right: 5px;
	}
	.button:hover {
		background: #ff5e2a;
		color: #ebebeb;
	}
	.button:focus {
		background: #ff5e2a;
		color: #ebebeb;
	}
	.ability-detail-icon-right {
		width: 31px;
		height: 32px;
		background: #eeeeee;
		// background: #ff5e2a;
		border-radius: 3px 3px 3px 3px;
		margin-right: 8px;
	}
	.ability-detail-button {
		width: 77px;
		height: 32px;
		background: #eeeeee;
		border-radius: 4px 4px 4px 4px;
		margin-right: 8px;
	}
	.ability-detail-body {
		max-width: max-content;
		// 左边对齐
		margin-left: 58px;
		display: flex;
		flex-direction: column;

		// align-items: center;
	}
	.ability-detail-body-title {
		:deep(p) {
			line-height: 1 !important;
			font-size: 24px !important;
		}
		font-size: 24px !important;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #3e3e3e;
		margin-top: 40px;
		margin-bottom: 10px;
		margin-right: 58px;
		// max-width: 696px;
		min-width: 400px;
		display: flex;
		flex-wrap: wrap;
		align-items: baseline;
		// justify-content: center;
	}
	.ability-detail-resource {
		margin-bottom: 20px;
	}
	.gird {
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-column-gap: 60px;
		max-width: 1080px;
	}
	.ability-detail-radio {
		// max-width: 696px;
		max-width: 500px;
		min-width: 400px;
		border-radius: 6px 6px 6px 6px;
		border: 1px solid #ffd4c6;
		display: flex;
		align-items: center;
		padding: 22px 10px;
		margin-bottom: 30px;
		overflow: hidden;
		.radio-item {
			display: flex;
			align-items: center;
			margin-left: 10px;
			flex: 1;
			max-height: 150px;
			overflow: auto;
		}
	}
	.ability-detail-radio-active {
		border: 1px solid #ff5e2a !important;
	}
	.ability-detail-audio {
		height: 180px;
	}
}
</style>
